import { InjectionToken } from '@angular/core';
import { ClickCategory } from '@mkp/shared/models';

/**
 * Lives in a `type:util` lib, not in `@mkp/shared/models`: an `InjectionToken` imports
 * `@angular/core`, every `type:models` lib runs Jest on the plain `ts-jest` preset, and exporting
 * this from the models barrel broke `credit-models` with `Cannot use import statement outside a
 * module`. `click` returns void so this file never names `FullTrackingEvent` — that type lives in
 * `@mkp/tracking/models` and importing it here is a cross-scope error.
 */
export interface ClickTracker {
  click(clickCategory: ClickCategory): void;
}

export const CLICK_TRACKER = new InjectionToken<ClickTracker>('CLICK_TRACKER', {
  // Throws rather than no-ops: an unbound app must fail loudly, not render blank ACUL screens.
  factory: () => {
    throw new Error(
      'CLICK_TRACKER is not bound. Provide it at the app composition root, e.g. useExisting over TealiumService.'
    );
  },
});
